const operationsMapping = {
  CREATE_OBJECTIVE: 'Create Objectives',
  CREATE_KR: 'Create KRs',
  UPDATE_KR: 'Edit(Obj.+KRs)',
  CHECK_IN: 'Check-in(Obj.+KRs)'
};
export default operationsMapping;

// We might use this in the future
// const operationsMapping = {
//   CREATE_OBJECTIVE: 'Create Objectives',
//   UPDATE_OBJECTIVE: 'Edit Objectives',
//   CREATE_KR: 'Create KRs',
//   UPDATE_KR: 'Edit KRs',
//   CHECK_IN: 'Check In(Obj.+KRs)'
// };

export const objectiveOperationKeys = {
  CREATE_OBJECTIVE: 'CREATE_OBJECTIVE',
  CREATE_KR: 'CREATE_KR',
  UPDATE_OBJECTIVE: 'UPDATE_OBJECTIVE',
  UPDATE_KR: 'UPDATE_KR',
  CHECK_IN: 'CHECK_IN'
};

export const personaListMapping = {
  ADMIN: {
    key: 'ADMIN',
    value: 'Admin'
  },
  MANAGER: {
    key: 'MANAGER',
    value: 'Manager'
  },
  USER: {
    key: 'USER',
    value: 'Employee'
  }
};

export const objectiveTypeMapping = {
  COMPANY: {
    key: 'COMPANY',
    value: 'Company'
  },
  NON_ALIGNED: {
    key: 'NON_ALIGNED',
    value: 'Independent'
  }
};

export const objectiveTypeOptions = [
  {
    value: [],
    text: 'None'
  },
  {
    value: ['COMPANY'],
    text: 'Company'
  },
  {
    value: ['NON_ALIGNED'],
    text: 'Independent'
  },
  {
    value: ['COMPANY', 'NON_ALIGNED'],
    text: 'Company + Independent'
  }
];

export const getListOfPersonasFromAccessControlSettings = settings => {
  const personas = [];
  settings.forEach(item => {
    personas.push(item.persona);
  });

  return personas;
};

export const getRestrictedOperationsForObjectiveType = (
  setting,
  objectiveType
) => setting[objectiveType];

export const getRestrictedSettings = (settings, operation) => {
  const types = [];
  Object.keys(objectiveTypeMapping).forEach(item => {
    if (settings[item]?.includes(operation)) types.push(item);
  });
  return types;
};

export const getUnselectedOperations = operations =>
  Object.keys(objectiveTypeMapping).filter(op => !operations.includes(op));

export const getCurrentSettingForPersona = (persona, settings, operation) => {
  const personaSettings = settings.find(item => item.persona === persona)
    ?.restricted_operations_map;
  let restrictedOperations = [];
  if (personaSettings) {
    restrictedOperations = getRestrictedSettings(
      personaSettings,
      operation,
      persona
    );
  }

  return getUnselectedOperations(restrictedOperations);
};

export const shouldDisableOptionForUser = (
  persona,
  value,
  managerSelectedObjectiveTypes
) => {
  if (persona === personaListMapping.USER.key) {
    if (!value.length) return false; // empty option; always allowed

    if (managerSelectedObjectiveTypes.length === 2) return false; // manager has no restrictions, so employee can have no restrictions

    if (value.length === 2) return true; // if above statement is false, we can't have both options enabled for the user

    if (!managerSelectedObjectiveTypes.includes(...value)) return true;
  }

  return false;
};
